import { Box, Typography } from '@mui/material';
import { WD } from '../../../warningDashboard/warningTheme';

/** A card's heading: title, an optional hint under it, and anything on the right (a count, filter chips). */
export default function PanelTitle({ title, hint, right }) {
  return (
    <Box display="flex" alignItems="flex-start" justifyContent="space-between" gap={2} flexWrap="wrap">
      <Box sx={{ minWidth: 0 }}>
        <Typography component="h2" sx={{ fontSize: 16, fontWeight: 700, color: WD.ink }}>{title}</Typography>
        {hint && <Typography sx={{ fontSize: 12, color: WD.inkMuted, mt: 0.25 }}>{hint}</Typography>}
      </Box>
      {right}
    </Box>
  );
}
